'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Notebook = function (_React$Component) {
    _inherits(Notebook, _React$Component);

    function Notebook() {
        _classCallCheck(this, Notebook);

        return _possibleConstructorReturn(this, (Notebook.__proto__ || Object.getPrototypeOf(Notebook)).apply(this, arguments));
    }

    _createClass(Notebook, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, {
                    d: 'M25.592 24.17h-19.169c-1.879 0-2.118-0.445-2.208-0.613-0.118-0.22-0.097-0.481 0.057-0.713l1.463-2.46c0.293-0.538 1.082-0.855 2.161-0.855l16.222 0.097c1.061 0 1.699 0.245 2.129 0.814l1.499 2.416c0.194 0.418 0.083 0.684 0.002 0.81-0.324 0.504-1.174 0.504-2.157 0.504zM5.118 23.157c0.22 0.063 0.653 0.127 1.305 0.127h19.168c0.38 0 1.039 0 1.326-0.079l-1.403-2.263c-0.183-0.244-0.506-0.428-1.399-0.428l-16.223-0.097c-0.921 0-1.311 0.266-1.387 0.407l-1.389 2.334z' }),
                _react2.default.createElement(Path, {
                    d: 'M18.904 27.182h-5.792c-0.443 0-0.746-0.117-0.899-0.348-0.111-0.17-0.127-0.381-0.040-0.579l0.433-1.186c0.111-0.363 0.478-0.603 0.953-0.603l4.906 0.047c0.447 0 0.762 0.193 0.935 0.573l0.459 1.184c0.095 0.334-0.010 0.533-0.079 0.625-0.217 0.286-0.582 0.286-0.875 0.286zM13.099 26.295c0.003 0 0.009 0 0.012 0h5.793c0.005 0 0.009 0 0.014 0l-0.336-0.866c-0.010-0.017-0.036-0.030-0.121-0.030l-4.906-0.047c-0.092 0-0.125 0.024-0.125 0.024l-0.331 0.918z' }),
                _react2.default.createElement(Path, {
                    d: 'M24.53 17.288h-17.44c-0.123 0-0.222-0.099-0.222-0.222v-11.873c0-0.122 0.098-0.221 0.222-0.221h17.44c0.122 0 0.222 0.099 0.222 0.221v11.874c0 0.123-0.099 0.222-0.221 0.222zM7.311 16.845h16.997v-11.43h-16.997v11.43z' }),
                _react2.default.createElement(Path, {
                    d: 'M28.682 28.67h-25.297c-0.947 0-2.61-0.144-3.101-1.11-0.134-0.263-0.284-0.807 0.218-1.494l3.439-5.935c0.44-0.821 0.952-1.448 1.824-1.723-0.869-0.557-1.443-1.496-1.443-2.56v-9.424c0-1.706 1.479-3.093 3.296-3.093h16.387c1.817 0 3.294 1.387 3.294 3.093v9.424c0 1.129-0.646 2.118-1.609 2.66 1.148 0.122 1.584 0.705 2.208 1.538l0.187 0.249 3.514 5.818c0.402 0.683 0.274 1.195 0.095 1.507-0.494 0.868-1.911 1.050-3.011 1.050zM6.856 19.585c-0.942 0-1.28 0.313-1.754 1.195l-3.488 6.011c-0.123 0.173-0.131 0.229-0.131 0.229 0.079 0.060 0.765 0.32 1.903 0.32h25.297c1.143 0 1.773-0.248 1.858-0.381 0 0.002-0.001 0.002-0.001 0.002-0.007 0-0.022-0.064-0.083-0.167l-3.623-5.952c-0.653-0.871-0.769-1.029-1.63-1.029l-2.439-0.028v-2.172h1.24c1.082 0 1.964-0.793 1.964-1.767v-9.424c0-0.973-0.881-1.763-1.964-1.763h-16.388c-1.084 0-1.966 0.79-1.966 1.763v9.424c0 0.973 0.881 1.767 1.966 1.767h1.356v1.997l-2.118-0.026zM10.192 19.633v-2.019h11.355v2.011l-11.355 0.009z' }),
                _react2.default.createElement(Path, {
                    d: 'M21.564 15.224l-0.35 0.308-0.901-1.006-0.346 0.31-0.111-1.51zM21.564 15.224l0.339-0.309-0.902-1.006 0.348-0.31-1.493-0.272z' })
            );
        }
    }]);

    return Notebook;
}(_react2.default.Component);

Notebook.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Notebook;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/notebook.js
// module id = 1115
// module chunks = 0